export const AdminAnalyticsExcludedIpController = {
    myIp(): void {},
    store(): void {},
    destroy(): void {},
};
